module.exports = __webpack_public_path__ + "media/images/icon_list/sns_movie-d847a775fa357e6b082c818ef03cf70b.svg";